import React, { ReactNode } from 'react';
import styled from 'styled-components';
import {
  BodyText,
  CaptionLink,
  EditIcon,
  Flex,
  IconButton,
  Stack,
  theme
} from '@kvdbil/components';
import { useTranslation } from '~/Locale';

const Card = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  border: 2px solid ${({ theme }) => theme.colors.grayscaleToned.light6};
  border-radius: 0.5rem;
  box-sizing: border-box;
`;

export interface DeliveryLocationSummaryCardProps {
  bodyText: ReactNode;
  detailText: ReactNode;
  onEdit(): void;
}

export const DeliveryLocationSummaryCard = ({
  bodyText,
  detailText,
  onEdit
}: DeliveryLocationSummaryCardProps) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Flex justify="space-between" align="flex-start" gap={1}>
        <Stack spacing={0.25}>
          <BodyText>{bodyText}</BodyText>
          <CaptionLink>{detailText}</CaptionLink>
        </Stack>
        <IconButton
          color="info"
          colorShade="dark"
          isActive={false}
          isDisabled={false}
          onClick={onEdit}
        >
          <EditIcon
            title={t('Edit')}
            color={theme.colors.info.dark}
            width="1.25rem"
            height="1.25rem"
          />
        </IconButton>
      </Flex>
    </Card>
  );
};

export default DeliveryLocationSummaryCard;
